/*
 * @Author: zhangqf
 * @Date: 2018-11-26 14:57:40 
 * @Last Modified by: Scherger
 * @Last Modified time: 2020-08-17 18:03:39
 */

import {
  SERVER
} from "@/api/apiConfig.js";
import sessionFun from "@/utils/cc-webapp/login.js";

import UTILS from "@/utils/utils.js";


import axios from 'axios';

var _appId = "";
//默认Android
var _nativeData = "";


function setAppId(appId) {
  _appId = appId
}

//设置应用信息
function setNative(data) {
  _nativeData = data
  // _nativeData.system = "android"
}



// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}


/**
 * 区块请求方法
 * @param  {object} url  请求链接
 * @param  {String} params 是否显示区块(默认)
 * @param  {String} returnName 直接返回清单数据
 */
function blockAxios(url, params, returnName) {
  return this.doAxios(url, params, 'GET').then(res => {
    return returnName ? res[returnName] : res
  })
}


/**
 * 上报本地缓存中的请求 
 * @param  {String} storageName 缓存 key
 */
function reportStorageRequest(storageName) {
  var requestStorage =    localStorage.getItem(storageName); //native.getStorage(storageName);

  // console.log('reportStorage', requestStorage);


  if (requestStorage) {
    var epubRequest = JSON.parse(requestStorage);

    // console.log('epubRequest', epubRequest);



    for (const requestUrl in epubRequest) {
      const requestData = epubRequest[requestUrl];

      requestData.forEach((v, k) => {

        if (v.requestType == 'doSessionAxios') {



          doSessionAxios(v.url, v.params, v.method, 'no login', v.isSession).then(() => {
            //请求成功

            if (epubRequest[requestUrl].length == 1) {
              //只有一个的时候整个删除
              delete epubRequest[requestUrl]

            } else {
              //删除数组
              let arr = epubRequest[requestUrl]
              arr.splice(k, 1)
              epubRequest[requestUrl] = arr
            }

            var setData = {
              key: 'epub_request',
              value: JSON.stringify(epubRequest)
            };

            //native.setStorage(JSON.stringify(setData));
            localStorage.setItem('epub_reques', JSON.stringify(epubRequest));

          })
        } else {
          doAxios(v.url, v.params, v.method).then(() => {
            //请求成功

            if (epubRequest[requestUrl].length == 1) {
              //只有一个的时候整个删除
              delete epubRequest[requestUrl]

            } else {
              //删除数组
              let arr = epubRequest[requestUrl]
              arr.splice(k, 1)
              epubRequest[requestUrl] = arr
            }

            var setData = {
              key: 'epub_request',
              value: JSON.stringify(epubRequest)
            };

            //native.setStorage(JSON.stringify(setData));
            localStorage.setItem('epub_reques', JSON.stringify(epubRequest));


          })
        }



      });

    }

  }



}

/**  将请求结果缓存到本地
 * @param  {Object} data 所有参数
 * @param  {Object} url url请求
 * @param  {Object} params 参数
 * @param  {Object} id  params中的id 参数
 * @param  {Object} method 请求类型
 * @param  {Object} isLogin 是否需要跳转login  
 * @param  {Object} isSession  外部传入session， 
 * 
 */
function setRequestData(data) {

  var requestStorage =  localStorage.getItem('request_data');//native.getStorage('request_data');
  var requestD = {}
  var isStorage = false

  // console.log('setStorage', data);

  if (requestStorage) {

    var epubRequest = JSON.parse(requestStorage)

    //request有缓存
    requestD = epubRequest

    for (const storageUrl in epubRequest) {
      const v = epubRequest[storageUrl];

      if (storageUrl == data.url) {
        // 有缓存过 覆盖
        isStorage = true
        requestD[storageUrl] = data
      } else if (storageUrl == (data.url + '_' + data.id)) {
        //url_id 的數據緩存形式
        isStorage = true
        requestD[data.url + '_' + data.id] = data
      }

    }
  }

  if (!requestStorage || !isStorage) {
    //request 没有缓存
    if (data.id) {
      //帶有id的形式
      requestD[data.url + '_' + data.id] = {}
      requestD[data.url + '_' + data.id] = data
    } else {
      requestD[data.url] = {}
      requestD[data.url] = data
    }

  }


  var setData = {
    key: 'request_data',
    value: JSON.stringify(requestD)
  };


  //native.setStorage(JSON.stringify(setData));
  localStorage.setItem('request_data', JSON.stringify(requestD));

}

/**
 *  返回缓存中的数据
 * 
 * @param  {String} url
 */
function returnStorageData(url) {

  var requestStorage = localStorage.getItem("request_data");//native.getStorage("request_data");

  if (requestStorage) {
    //存在缓存

    let storageD = JSON.parse(requestStorage)

    for (const storageUrl in storageD) {

      if (url == storageUrl) {
        return storageD[storageUrl];
      }

    }

  } else {
    //没有缓存
    return false
  }


}

// 并发请求方法（多个接口同步同步）
/** 
 * @example
 * this.GLOBAL_.ccRequest
        .allAxios(this.p1(), this.p2(), this.p2())
        .then(reload => {
          console.log("完成");
        });
 */
function allAxios() {
  return axios.all([].slice.call(arguments))
    .then(axios.spread(function (acct, perms) {
      // 两个请求现在都执行完成

      return {
        acct,
        perms
      }

    }));
}

/** 不带session請求方法
 * @param  {string} url 请求url
 * @param  {data} params 请求携带参数
 * @param  {string} method  默认POST  可传入 GET / POST
 * @param  {string} isAllUrl  url是否带端口
 */
function doAxios(url, params, method, isAllUrl) {
  let m = method ? method : "POST" //默认使用POST

  console.log('cc-webapp')
  return new Promise(function (resolve, reject) {

    return apiAxios(m, url, params, false, isAllUrl).then(res => {
      resolve(res)
    }).catch(e => {
      reject(e)
    })

  })

}

/** 带session请求
 * @param  {string} url 请求url
 * @param  {data} params 请求携带参数
 * @param  {string} method  默认POST  可传入 GET / POST
 * @param  {Boolean } isLogin  是否需要跳转login  
 * @param  {string } isSession  外部传入session，   
 * @param  {string } isStorage  是否缓存， 默认不缓存    
 * @param  {Boolean } isAllUrl  開發調試
 * @Examples
 * isLogin 为检查session 当为空的时候是否需要跳转登录页判断，
 * 为兼容以调用过的请求， 所以默认为跳转登录页
 * 按照调用语义 ，调用的时候可传入 ‘no login’
 * doSessionAxios(url, params, method, 'no login')
 * @Examples
 * isSession 为外部传入，默认不传入自动获取本地session，
 * 当前用于新用户注册邮箱预传入，绑定成功才缓存到本地。
 * 
 */
function doSessionAxios(url, params, method, isLogin, isSession, isStorage, isAllUrl) {
  // console.log('sessionAxios', url);

  let m = method ? method : "POST" //默认使用POST
  var loginFlag = false

  if (isLogin) {
    loginFlag = true
  }



  return new Promise(function (resolve, reject) {


    //如果存在外部传入session就使用外部的
    if (isSession) {

      return apiAxios(m, url, params, isSession, isAllUrl).then(res => {
        if (isStorage) {

          setRequestData({
            url: url,
            id: params.id,
            resultData: res
          })
        }
        resolve(res)

      }).catch(e => {
        // console.log('session api catch', e);

        console.log('跳到了没有session的catch里面',e);

        if (e.response.status == 500) {
          native.showToast(e.response.data.message);
        }

        if (e.response.data.code == 40101) {
          // alert('login2 request 40101')
          //native.removeStorage('app_session');
          localStorage.removeItem('app_session');
          native.showToast("用戶已過期請退出重新登錄");
          sessionFun.go()

        } else if (e.response.data.code == 40102) {

          native.showToast("該用戶已被系統停用");

        } else {
          reject(e)
        }

      })

    } else {

      return sessionFun.check(loginFlag).then(w_session => {

        // console.log(w_session);



        //不跳登錄頁且沒有獲取到session時
        if (loginFlag && w_session.session == null) {
          let e = {
            isLogin: false
          }
          return reject(e)
        }

        // console.log("sessionFun", w_session);

        return apiAxios(m, url, params, w_session).then(res => {
          if (isStorage) {
            setRequestData({
              url: url,
              id: params.id,
              resultData: res
            })
          }
          resolve(res)
          // console.log(res);

        }).catch(e => {
          // console.log('catch');

          if (e.response.status == 500) {
            native.showToast(e.response.data.message);
          }

          if (e.response.data.code == 40101) {
            // alert('login2 request 40101 2')
            //native.removeStorage('app_session');
            localStorage.removeItem('app_session');
            native.showToast("用戶已過期請退出重新登錄");
            sessionFun.go()

          } else if (e.response.data.code == 40102) {

            native.showToast("該用戶已被系統停用");

          } else {
            reject(e)
          }
        })

      }).catch(err => {

        return apiAxios(m, url, params, false).then(res => {

          if (isStorage) {

            setRequestData({
              url: url,
              id: params.id,
              resultData: res
            })
          }
          resolve(res)
          // console.log(res);

        }).catch(e => {
          if (e.response.status == 500) {
            native.showToast(e.response.data.message);
          }

          if (e.response.data.code == 40101) {
            // alert('login2 request 40101 3')
            //native.removeStorage('app_session');
            localStorage.removeItem('app_session');
            native.showToast("用戶已過期請退出重新登錄");
            sessionFun.go()

          } else if (e.response.data.code == 40102) {

            native.showToast("該用戶已被系統停用");

          } else {
            reject(e)
          }
        })



      })

    }


  })

}



// 底层请求方法
function apiAxios(method, url, params, app_session, isAllUrl) {

  return new Promise(function (resolve, reject) {
    var sendUrl = ''
    if (!isAllUrl) {
      sendUrl = SERVER.URL + url
    } else {
      sendUrl = url
    }


    //填入設備類型參數
    params.clientType = _nativeData.system
    // params.clientType = ""

    //console.log("apiAxios app_session", _nativeData)

    //过滤空参数
    if (params) {
      params = filterNull(params)
    }

    //传入APPID 参数
    if (!params.appId) {
      params.appId = _appId
    }

    //獲取語言
    let langData = native.getStorage("lang");
    let lang = "zh-hk";
    if (langData && JSON.parse(langData).type == true) {
      lang = JSON.parse(langData).lang
    }


    let obj = {}
    obj['method'] = method
    obj['url'] = sendUrl
    obj['data'] = method === 'POST' || method === 'PUT' ? params : null
    obj['params'] = method === 'GET' || method === 'DELETE' ? params : null
    obj['headers'] = {
      // 'Content-type': 'application/x-www-form-urlencoded',
      'clientType': _nativeData.system,
      'versionCode': _nativeData.versionCode,
      'appVersion': _nativeData.appVersion,
      'deviceId': _nativeData.deviceId,
      'network': _nativeData.networkStatus,
      'htmlVersion': _nativeData.htmlVersion,
      'language': lang
    }

    

    if (app_session) {
      obj['headers']['session'] = app_session.session

    }


    obj['withCredentials'] = false


    if (method == "POSTJSON") {
      obj['headers']['Content-type'] = 'application/json'
      obj['method'] = "POST"
      obj['data'] = JSON.stringify(params);
      obj['dataType'] = "json"
    } else {
      obj['headers']['Content-Type'] = 'application/x-www-form-urlencoded'
    }





    if (method != "POSTJSON") {
      obj['transformRequest'] = [function (data) {
        //post 請求不格式化
        // if (method == "POST") {
        //   console.log("data", data)
        //   return data;
        // }
        let ret = ''
        for (let it in data) {
          if (data[it] instanceof Array) {
            // 数组
            for (let item in data[it]) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it][item]) + '&'
            }
          } else {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
        }
        return ret
      }]

    }



    axios(obj).then((res) => {




      resolve(res.data)
    }).catch((err) => {
      // console.log(err)

      UTILS.checkNetWork(0).then(() => {
        //沒網狀態

        if (url == 'api/media/data/get') {
          url = url + '_' + params.id
        }

        let storageData = returnStorageData(url)

        if (storageData) {
          //找到緩存中的數據
          resolve(storageData.resultData)

        }

      }).catch(() => {
        //有網

        if (err.response.status == 500) {

          native.showToast(err.response.data.message);
        }
        reject(err)
      })





    })

  })

}


function merge(url, obj) {

  //構造請求體
  let postD = [];
  for (let i in obj) {
    let d = {
      id: i
    }
    let item = obj[i];
    let u = item.url + "?"
    let pStr = '';
    for (let p in item.param) {
      let pVal = item.param[p];
      if (typeof (pVal) === "Object") {
        pStr += `&${p}=${JSON.stringify(pVal)}`
      } else {
        pStr += `&${p}=${pVal}`
      }
    }
    u += pStr;
    d.url = u;
    postD.push(d)

  }
  url += "?data=" + encodeURIComponent(JSON.stringify(postD)); //不知道為什麼，反正這樣可以


  return doSessionAxios(url, {}, "GET", 'no login').then(res => {
    //將結果裝入OBJ
    for (let idx in res) {
      let id = res[idx].id;
      obj[id].data = res[idx].result
    }
    return obj

  }).catch(e => {
    // console.log(e);

  })

  // return apiAxios("GET", url, {}).then(res => {

  //   //將結果裝入OBJ
  //   for (let idx in res) {
  //     let id = res[idx].id;
  //     obj[id].data = res[idx].result
  //   }
  //   return obj
  // }).catch(e => {

  //   console.log(e);


  //   return e
  // })



}
//監控滾動觸底加載
/**
 * 
 * @param {Object} obj 請求參數
 * @param {Number} obj.pageNo 請求頁數 必填
 * @param {Number} obj.pageSize 每頁頁數 默認10
 * @param {String} obj.url 請求路徑 必填
 * @param {String} obj.name 监控名称 必填
 */

var scrollArray = {}
/**
 * 清空數據
 */
function delectScrollArray() {
  scrollArray = {}
}

function scrollData(obj, resolve, reject) {
  let postD = obj;
  let nScroll = document.documentElement.scrollTop || document.body.scrollTop;
  postD.pageSize = postD.pageSize == undefined ? 10 : postD.pageSize; //默認條數
  let nClientHeight = document.documentElement.clientHeight;
  if (nScroll + nClientHeight >= document.body.scrollHeight - 50) {
    postD.pageNo = postD.pageNo + 1;
    native.showLoading();
    return doSessionAxios(postD.url, postD, "GET", "no login")
      .then(res => {
        native.hideLoading();
        if (res.rows.length == 0) {
          obj.load = false;
          native.showToast("到底啦!")
        } else {
          obj.load = true;
        }
        scrollArray[obj.name] = obj
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }
}

function getScrollData(obj) {
  return new Promise((resolve, reject) => {
    if (scrollArray[obj.name]) {
      if (scrollArray[obj.name].load) {
        scrollData(scrollArray[obj.name], resolve, reject)
      }
    } else {
      scrollData(obj, resolve, reject)
    }

  })
}



export default {
  setAppId,
  doAxios,
  blockAxios,
  allAxios,
  merge,
  doSessionAxios,
  setNative,
  getScrollData,
  delectScrollArray,
  reportStorageRequest,
}



// WEBPACK FOOTER //
// ./src/utils/cc-webapp/request.js